export default "__VITE_ASSET__29ce16d7__"